/**
 * Full Sail's engine host, as a box's app reports it in /api/health and the
 * helm-agent forwards it. A machine fact about the runtime container, the
 * same side of the heartbeats line as runtime_ok.
 */
export const ENGINE_HOST_STATES = ["ok", "unreachable", "protocol_mismatch"] as const;
export type EngineHostState = (typeof ENGINE_HOST_STATES)[number];

export function engineHostState(value: unknown): EngineHostState | null {
  return ENGINE_HOST_STATES.find((state) => state === value) ?? null;
}

export function engineHostLabel(value: string | null): string {
  switch (engineHostState(value)) {
    case "ok":
      return "Ready";
    case "unreachable":
      return "Not running";
    case "protocol_mismatch":
      return "Needs runtime update";
    default:
      return "Not reported";
  }
}
